
<template>
  <div class="record_box"
       style="height:100%;">
    <div ref="mescroll"
         class="mescroll noticeBox">
      <div>
        <div class="header">
          <p class="balance">金币余额</p>
          <p class="bal_money">{{gold}} <span class="dw"></span></p>
        </div>
        <div class="record_item"
             id="noticeList">
          <div class="item"
               v-for="(item,idx) in balanceList"
               :key="idx">
            <div class="info">
              <p class="title">{{item.description}}</p>
              <p class="time">{{item.gmtCreate}}</p>
            </div>
            <div class="money">
              <p>
                <span :class="{'add red':item.amount>0,'reduce gray':item.amount<=0}">{{item.amount>0?`+${item.amount}`:item.amount}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
  components: {
    MeScroll
  },
  data () {
    return {
      gold: '',
      customerId: '',
      balanceList: [],
      page: 1,
      pageSize: 10,
      mescroll: null, //mescroll实例对象
    }
  },
  mounted () {
    this.util.title('金币明细');
    this.customerId = this.$route.query.customerId
    let _this = this;
    _this.mescroll = new MeScroll(_this.$refs.mescroll, { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getBalanceList, //上拉回调
        page: {
          size: 10
        },
        clearEmptyId: 'noticeList',
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata">-- End --</p>'
      },
      down: {
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      }
    });
  },
  methods: {
    /**
            * 下拉刷新
            */
    downCallback () {
      this.balanceList = []//重置数组
      //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    getBalanceList (page, isLoadMore) {
      let _this = this;
      let param = {
        customerId: this.customerId,
        pageNum: page.num,
        pageSize: this.pageSize,
      }
      this.$get('/app/valueAdded/goldRecords', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.gold = e.data.gold;
            //产品分页
            let productList = e.data.data;
            _this.mescroll.endBySize(productList.length, e.data.total);
            _this.balanceList = _this.balanceList.concat(productList);
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { console.log('错误') });
    }

  }

}
</script>
<style scoped>
/* 非vip样式 */
.mescroll {
    position: fixed;
    padding-bottom: 1rem;
    top: 2px;
    bottom: 0;
    height: auto;
  -webkit-overflow-scrolling: touch;
}
.record_box {
  font-family: PingFangSC-Regular;
  background: #fff;
  padding: 0 0.15rem;
}
.header {
  width: 100%;
  height: 1.06rem;
  background: url("../../assets/img/vip/card/coins_bg.png") no-repeat center
    center;
  background-size: cover;
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 4px;
  margin: 0 auto;
  padding: 0.24rem 0.15rem 0.22rem 0.15rem;
  margin-bottom: 0.08rem;
  margin-top: 0.15rem;
}
.bal_money {
  font-family: DINAlternate-Bold;
  font-size: 0.4rem;
  color: #fff;
  position: relative;
  top: -0.06rem;
}
.balance {
  color: #fff;
  font-size: 0.12rem;
}
.dw {
  font-size: 0.14rem;
  top: -0.03rem;
  font-size: 0.14rem;
  position: relative;
  left: -0.06rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.12rem;
  font-size: 0.14rem;
  padding-top: 0.12rem;
}
.item .title {
  color: #333;
}
.item .time {
  color: #999;
}
.item .gray {
  color: #666;
  font-size: 0.26rem;
}
.item .red {
  color: #ff514a;
  font-size: 0.26rem;
}
.redDw {
  color: #ff514a;
  font-size: 0.14rem;
}
.grayDw {
  color: #666;
  font-size: 0.14rem;
}
</style>
